import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { connect } from 'react-redux';
import cartAnalytics from './cartAnalytics';
import Textarea from '../Elements/Textarea/Textarea';
import Button from '../Elements/Button/Button';
import { changeQuantity, changeSize, updateKlarna, addToBag } from '../../actions/checkout';
import { toggleFavourite } from '../../actions/environment';
import FakeSelect from '../Elements/FakeSelect/FakeSelect';
import { purifier } from '../../utils/dom';
import { translate, prefix } from '../../utils/string';
import { translateObjectData } from '../../utils/locale';
import Price from '../Product/Price';
import s from './CartItems.scss';

class CartItems extends Component {
	constructor(props) {
		super(props);

		this.state = {
			message: '',
			personalized: {}, // { 24-234: { presentItem: 224-45, message: '' } }
		};
	}

	updateQuantityHandler = (e) => {
		e.preventDefault();
		const { checkout, currentPage, setup } = this.props;
		const $link = e.currentTarget;
		const itemId = $link.closest('.checkoutItem').dataset.item;
		const itemObj = checkout.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === itemId ? item : {}) }), {});
		const cachedItem = Object.keys(checkout.selectionCache).filter((scItem) => scItem === itemId.split('-')[0]).map((scItem) => checkout.selectionCache[scItem])[0];
		const action = $link.getAttribute('href').slice(1);
		let quantity = itemObj.quantity;
		let analyticsQuantity = 1;

		switch (action) {
			case 'increase':
				quantity += 1;
				break;
			case 'decrease':
				quantity -= 1;
				break;
			case 'remove':
				quantity = 0;
				analyticsQuantity = itemObj.quantity;
				break;
			default:
				break;
		}

		this.props.changeQuantity(itemObj, quantity)
			.then((response) => {
				if (currentPage === 'selection') {
					this.props.updateKlarna();
				}

				const itemObject = response?.selection?.items && response.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === itemId ? item : {}) }), {});
				cartAnalytics(cachedItem, itemObject, setup, false, checkout.listItemCache, ['remove', 'decrease'].indexOf(action) !== -1, analyticsQuantity);

				return response;
			}).catch((err) => console.log('DEBUG: quantity did not change', err));
	}

	openPersonalizeItem = (e) => {
		e.preventDefault();
		const item = e.currentTarget.parentElement.dataset.item;
		const giftWrap = e.currentTarget.parentElement.dataset.giftWrap;

		this.setState((prevState) => {
			if (prevState.personalized[item]) {
				return {
					personalized: {
						...prevState.personalized,
						[item]: null,
					},
				};
			}

			return {
				personalized: {
					...prevState.personalized,
					[item]: {
						giftWrap,
						message: '',
					},
				},
			};
		});
	}

	personalizeItem = (e) => {
		e.preventDefault();
		const { personalized } = this.state;
		const $form = e.currentTarget;
		const item = $form.dataset.item;

		if (personalized[item]) {
			const { checkout, currentPage, setup, productCache } = this.props;
			const { products = {} } = (productCache[setup.market] && productCache[setup.market][setup.pricelist]) || {};

			const productId = item.slice(0, item.indexOf('-'));
			let wrappedProduct = checkout.selectionCache[productId];
			if (!wrappedProduct && products) wrappedProduct = products[productId];
			let sizeName = '';
			wrappedProduct.sizes.forEach((size) => {
				if (size.item === item) sizeName = size.name;
			});

			const wrappingId = personalized[item].giftWrap.slice(0, personalized[item].giftWrap.indexOf('-'));
			const cachedProduct = products[wrappingId];

			const note = {
				item,
				message: `Product: ${wrappedProduct.name} — Size: ${sizeName} — Message: ${personalized[item].message}`,
				details: { ...personalized[item] },
			};
			cartAnalytics(cachedProduct, {}, setup, false, checkout.listItemCache);
			this.props.addToBag(personalized[item].giftWrap, 1, currentPage, cachedProduct, note);
		}
	}

	setMessage = (id, value) => {
		const item = id.replace('message_', '');
		let filteredValue = purifier(value, { ALLOWED_TAGS: [] });
		filteredValue = filteredValue.replace(/(\s)+/g, '$1');
		if (filteredValue.length > 100) filteredValue = filteredValue.slice(0, 100);

		this.setState((prevState) => ({
			message: filteredValue,
			personalized: {
				...prevState.personalized,
				[item]: {
					...prevState.personalized[item],
					message: filteredValue,
				},
			},
		}));
	}

	renderGiftItem = (additionalInformation, giftWrap) => (
		<div className={s.cartItem_personalized}>
			<div className={s.cartItem_personalized_product}>{`${giftWrap[0].name} (${giftWrap[0].priceEach.replace(/\.00\s/, ' ')})`}</div>
			<div className={s.cartItem_personalized_message}>{ additionalInformation[0].details.message }</div>
		</div>
	)

	renderCustomizeGiftWrap = (item, giftWrapChoices, setup, personalized, message) => (
		<>
			<div className={s.cartItem_closePersonalize} data-item={item.item}>
				<a className={s.cartItem_closePersonalize_link} href="#remove-personalization" onClick={this.openPersonalizeItem} aria-labelledby="Remove Gift Wrap">
					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
						<g fill="none" stroke="#FFF" strokeLinecap="square" strokeWidth="1.5" transform="rotate(-45 17.39 3.11)">
							<line x1="7.793" x2="7.793" y2="15" />
							<line x1="15" y1="7.707" y2="7.707" />
						</g>
					</svg>
				</a>
			</div>
			<div className={s.cartItem_personalize}>
				<form className={s.cartItem_personalize_form} onSubmit={this.personalizeItem} data-item={item.item}>
					<Textarea id={`message_${item.item}`} type="text" placeholder={translate(setup, 'giftWrapMessage')} value={personalized[item.item].message || message} inputChange={this.setMessage} />
					<div className={s.cartItem_personalize_form_submit}>
						<span>{`${translate(setup, 'giftWrapCharactersLeft')} ${100 - (personalized[item.item].message || message).length}`}</span>
						<Button variantClasses={['button__invert']} type="submit" text={`${translate(setup, 'giftWrapAdd')} (${giftWrapChoices[0].value})`} />
					</div>
				</form>
			</div>
		</>
	)

	renderAddGiftWrap = (item, giftWrapChoices, setup) => (
		<div className={s.cartItem_initPersonalize} data-item={item.item} data-gift-wrap={giftWrapChoices[0].key}>
			<Button type="a" href="#add-personalization" text={`${translate(setup, 'giftWrapAdd')} (${giftWrapChoices[0].value})`} clickEventHandler={this.openPersonalizeItem} />
		</div>
	)

	render() {
		const { checkout, currentPage, setup, productCache, favourites, isNavigation = false } = this.props;
		const { personalized, message } = this.state;
		const { products = {}, filterArrays = {} } = (productCache?.[setup.market]?.[setup.pricelist]) || {};
		const giftWrapItems = (filterArrays.giftWrapProduct && filterArrays.giftWrapProduct.length > 0 && filterArrays.giftWrapProduct.map((item) => products[item])) || [];
		const giftWrapChoices = giftWrapItems.map((item) => ({
			key: item.sizes[0].item,
			value: item.price.price.replace(/\.00\s/, ' '),
		}));

		const changeSizeHandler = (newItemId, target) => {
			const itemId = target.closest('.checkoutItem').dataset.item;
			const itemObj = checkout.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === itemId ? item : {}) }), {});

			this.props.changeSize(itemId.slice(0, itemId.indexOf('-')), itemObj.line, itemObj.quantity, newItemId)
				.then(() => (currentPage === 'selection' ? this.props.updateKlarna() : null)).catch((err) => console.log('DEBUG: size did not change'));
		};

		const moveToFavouritesHandler = (e) => {
			e.preventDefault();
			const productId = e.currentTarget.dataset.productId;

			this.props.toggleFavourite(productId, 'selection');
		};

		const lineItems = checkout.selection.items ? checkout.selection.items.filter((item) => {
			// Filter out gift wrapping items and append them as text instead.
			const productId = item.item.slice(0, item.item.indexOf('-'));
			if (filterArrays.giftWrapProduct && filterArrays.giftWrapProduct.indexOf(productId) === -1) return true;
			return false;
		}).map((item) => {
			const productId = typeof item === 'object' ? item.item.slice(0, item.item.indexOf('-')) : item;
			const itemCache = checkout.selectionCache[productId] || products[productId] || {};
			const itemDetails = translateObjectData(setup, itemCache);
			const oneSizeArray = ['os', 'onesize', 'one size'];
			if (item.quantity === 0 || !itemDetails) return null;

			const additionalInformation = checkout.payment.additionalInformation.filter((customItem) => item.item === customItem.item);
			const giftWrap = additionalInformation.length > 0 ? checkout.selection.items.filter((selectionItem) => additionalInformation[0].details.giftWrap === selectionItem.item) : [];

			const price = {};
			const formattedSizes = itemDetails.sizes ? itemDetails.sizes.map((sizeItem) => ({
				key: sizeItem.item,
				value: sizeItem.name,
				disabled: sizeItem.stock === 0,
				selected: item.size === sizeItem.item,
			})) : false;

			Object.keys(item).forEach((priceItem) => {
				if (priceItem.indexOf('price') === 0) price[priceItem.replace('priceEach', 'price')] = item[priceItem];
			});

			return (
				<div key={item.item} className={[s.cartItem, (isNavigation ? s.cartItem__navigation : null), 'checkoutItem'].join(' ')} data-item={item.item}>
					<Link className={s.cartItem_image} to={prefix(setup, (itemDetails.category ? itemDetails.category : itemDetails.canonicalUri))}>
						{ itemDetails?.image?.[0] && <img src={itemDetails.image[0].replace('-big.jpg', '-thumb.jpg')} alt={itemDetails.name} /> }
					</Link>
					{
						currentPage === 'selection' && (
							<a href="#addToFavourites" data-product-id={productId} onClick={(e) => moveToFavouritesHandler(e)} className={s.cartItem_favourites}>
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
									<path fill={favourites.indexOf(productId) === -1 ? 'none' : '#663886'} stroke="#000" strokeWidth="1.3" d="M82.3607178,44.9685735 C89.1964111,38.2322454 85.5537109,32.7345647 81.5004883,32.0919866 C78.7983398,31.6636012 76.7208802,32.7314723 75.0893698,35.2955999 C73.4578594,32.7314723 71.3803998,31.6636012 68.6782514,32.0919866 C64.6250287,32.7345647 60.9823285,38.2322454 67.8180219,44.9685735 C70.9248433,48.0302334 73.289046,50.256918 75.0893698,51.6486272 C76.8896936,50.256918 79.2538964,48.0302334 82.3607178,44.9685735 Z" transform="translate(-63 -31)" />
								</svg>
							</a>
						)
					}
					<div className={s.cartItem_info}>
						<span className={s.cartItem_info_brand}>{ itemDetails.brand }</span>
						<span className={s.cartItem_info_name}>{ itemDetails.name }</span>
						{
							currentPage !== 'receipt' && (
								<div className={s.cartItem_info_changeQuantity}>
									<a className={s.cartItem_info_changeQuantity_remove} href="#remove" onClick={this.updateQuantityHandler}>×</a>
									<a className={s.cartItem_info_changeQuantity_button} href="#decrease" onClick={this.updateQuantityHandler}>-</a>
									<span className={s.cartItem_info_changeQuantity_quantity}>{ item.quantity }</span>
									<a className={s.cartItem_info_changeQuantity_button} href="#increase" onClick={this.updateQuantityHandler}>+</a>
									{
										oneSizeArray.indexOf(item.size.toLowerCase()) === -1 && formattedSizes !== false && !isNavigation && (
											<FakeSelect selectionHandler={(sizeItem, target) => changeSizeHandler(sizeItem, target)} items={formattedSizes} title={translate(setup, item.size)} adaption="invisible" />
										)
									}
								</div>
							)
						}
						{ (currentPage === 'receipt' || formattedSizes === false) && <span className={s.cartItem_info_name}>{ item.size }</span> }
						<span className={s.cartItem_info_price}><Price price={price} cart /></span>
						{ !itemDetails.noGiftWrap && additionalInformation.length > 0 && giftWrap.length > 0 && this.renderGiftItem(additionalInformation, giftWrap) }
					</div>
					{ giftWrapChoices.length > 0 && currentPage === 'selection' && !itemDetails.noGiftWrap && additionalInformation.length === 0 && personalized[item.item] && this.renderCustomizeGiftWrap(item, giftWrapChoices, setup, personalized, message) }
					{ giftWrapChoices.length > 0 && currentPage === 'selection' && !itemDetails.noGiftWrap && additionalInformation.length === 0 && !personalized[item.item] && this.renderAddGiftWrap(item, giftWrapChoices, setup) }
				</div>
			);
		}) : [];

		return (
			<div className={s.cartItems}>
				{ checkout.selection.items ? lineItems : <span>No Items</span> }
			</div>
		);
	}
}

const mapState = ({ environment, checkout, productCache }, { currentPage, isNavigation }) => ({
	checkout,
	setup: environment.setup,
	favourites: environment.favourites,
	productCache,
	currentPage,
	isNavigation,
});

export default hot(module)(connect(mapState, { changeQuantity, changeSize, updateKlarna, toggleFavourite, addToBag })(CartItems));
